import { render, staticRenderFns } from "./QuoteResume.vue?vue&type=template&id=6231b535&scoped=true&"
import script from "./QuoteResume.vue?vue&type=script&lang=js&"
export * from "./QuoteResume.vue?vue&type=script&lang=js&"
import style0 from "./QuoteResume.vue?vue&type=style&index=0&id=6231b535&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6231b535",
  null
  
)

export default component.exports